enum TimeFormat {
  "12H",
  "24H",
}

export default TimeFormat;
